<template>
  <div class="contact">
    <div id="headerContactPopover" class="contact__wrapper" >
      <VLazyImage
        :src="whatsappIcon"
        alt="Ícone do Whatsapp"
        class="contact__whatsapp-icon"
        width="22"
        height="22"
      />
      <span>
        <a
          class="link link--bold contact__link-color"
          href="https://web.whatsapp.com/send?l=pt&phone=558001232222" target="_blank"
        >
          <strong>Fale com a gente</strong>
        </a>
      </span>
    </div>
    <no-ssr>
      <b-popover
        target="headerContactPopover"
        container="headerContactPopover"
        triggers="hover"
        :html="true"
        placement="bottom"
      >
        <div class="contact__popover-text">
         Seg - Sex 8h-22h <br>
         Sáb 9h-13h <br>
         Aceitamos ligação de celular.
        </div>
      </b-popover>
    </no-ssr>
  </div>
</template>

<script>
  import QDivider from '~/components/q-divider';
  import VLazyImage from "v-lazy-image";

  import whatsappIcon from '~/assets/images/icons/brands/whatsapp.svg';

  export default {
    data() {
      return {
        whatsappIcon,
      };
    },
    components: {
      QDivider,
      VLazyImage,
    },
  };
</script>

<style lang="scss" scoped>
  @import '@quero/zilla-core/src/utils/functions.scss';
  @import '@quero/zilla-core/src/utils/variables.scss';

  .contact {
    display: flex;
  }

  .contact__wrapper {
    align-items: center;
    color: var(--color-neutral-gray-darker);
    display: flex;
    font-size: rem(14);
    line-height: rem(16);
  }

  .contact__whatsapp-icon {
    margin-right: $space-s;
  }

  .contact__popover-text {
    color: var(--color-neutral-gray-dark);
    font-size: rem(15);
    padding: $space-s $space-xs;
    text-align: center;
  }

  .contact__link-color {
    color: var(--color-brand-primary-pure);
  }
</style>
